import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UserOrganization, UserOrganizationResponse } from "~types/userOrganization";

const useFetchUserOrganizations = () => {
  const request = useApi();
  const { customerId } = useParams();

  return useQuery({
    queryKey: ["customer-organizations", customerId],
    queryFn: (): Promise<UserOrganization[]> =>
      request<UserOrganizationResponse>("user/organizations").then((response) => response?.data || []),
    staleTime: 5 * 60 * 1000,
  });
};

export default useFetchUserOrganizations;
